import { getPlans } from '@base/api';
import { useAuthStore } from '@fleek-platform/login-button';
import { useQuery } from '@tanstack/react-query';

export const usePlans = () => {
  const { accessToken } = useAuthStore();
  return useQuery({
    queryKey: ['plans'],
    queryFn: async () => {
      return getPlans(
        {
          accessToken,
        },
        {
          throwOnError: true,
        },
      );
    },
  });
};
